import { useQuery, useMutation, useQueryClient } from "react-query";
import { http } from "src/api/http";
import { TwilioRegistrationRecord, TwilioRegLog } from "./models";
import { toast } from 'sonner';

export function useTwilioMonitor() {
  return useQuery<TwilioRegistrationRecord[]>({
    queryKey: ["admin", "twilio-monitor"],
    queryFn: () => http("/api/admin/twilio-monitor")
  });
}

export function useTwilioMonitorDetail(id: string) {
  return useQuery<TwilioRegLog>({
    queryKey: ["admin", "twilio-monitor", id],
    queryFn: () => http(`/api/admin/twilio-monitor/${id}`),
    enabled: !!id
  });
}

export function useRestartFailedStepMutation(id: string) {
  const queryClient = useQueryClient();
  
  return useMutation(
    (logId: string) => http(`/api/admin/twilio-monitor/${logId}/restart`, {
      method: 'POST'
    }),
    {
      onSuccess: () => {
        toast.success('Registration step restart initiated');
        queryClient.invalidateQueries(["admin", "twilio-monitor", id]);
      },
      onError: (error: any) => {
        toast.error(`Failed to restart: ${error.message || 'Unknown error'}`);
      }
    }
  );
}

export function useActiveSessions() {
  return useQuery<TwilioRegistrationRecord[]>({
    queryKey: ["admin", "twilio-monitor", "sessions"],
    queryFn: () => http("/api/admin/twilio-monitor/sessions"),
    refetchInterval: 2000
  });
}
